export default __webpack_public_path__ + "static/media/ic_warning.7da83517.svg";